import { makeAutoObservable } from 'mobx';
import { RootStore } from 'app/store/rootStore';

export class StateStore {
  public rootStore: RootStore;

  public isSectionsLoading = false;
  public isSearchLoading = false;
  public isExplorerLoading = false;
  public isTrashLoading = false;
  public isTrashExplorerLoading = false;
  public isAuthStoreLoading = false;
  public isSomeLoading = false;

  public get isGlobalLoader() {
    return (
      this.isSectionsLoading ||
      this.isExplorerLoading ||
      this.isSearchLoading ||
      this.isTrashLoading ||
      this.isSomeLoading ||
      this.isTrashExplorerLoading
    );
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
}
